import React from "react";
import "./UiGame.scss"

const UiGame = ( {puntos,tiempo}:any ) => {
    return (
        <div className="UiGame">
            <div className="UiGame__boxInfo">
                <p className="UiGame__boxInfo-copy">Puntos:</p>
                <p className="UiGame__boxInfo-data">{puntos}</p>
                <p className="UiGame__boxInfo-copy">Tiempo:</p>
                <p className="UiGame__boxInfo-data">{tiempo}</p>
        </div>
           
        </div>
    );
}

export default UiGame;